import { useToast } from 'primevue/usetoast';
import { useRouter } from 'vue-router';
import { useAuthSession } from '~/composables/auth/useAuthSession';
import useAppStore from '~/stores/app';
import { $parseErrorMessage } from '~/utils/helpers';

export default function useLogout() {
  const loading = ref(false);
  const toast = useToast();
  const router = useRouter();

  const { signOut } = useAuthSession();
  const { toggleLoading } = useAppStore();

  const logout = async (): Promise<void> => {
    loading.value = true;
    toggleLoading(true, 'Logging out...');
    try {
      await signOut();
      toggleLoading(false);
      await router.push('/auth/login');
    } catch (error) {
      toast.add({
        severity: 'error',
        summary: $parseErrorMessage(error),
        life: 3000,
      });
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,

    logout,
  };
}
